import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';

import IconButton from 'components/common/IconButton';
import Button from 'components/common/Button';
import Link from 'components/common/Link';
import IconPlus from 'components/icons/IconPlus';
import IconFilter from 'components/icons/IconFilter';
import PatientsFilterForm from './PatientsFilterForm';

const styles = theme => ({
  root: {
    position: 'sticky',
    top: 124,
    zIndex: 21,
    marginBottom: 16,
    '&:before': {
      content: '""',
      position: 'absolute',
      bottom: -16,
      left: -8,
      right: -8,
      top: -16,
      zIndex: 1,
      backgroundColor: theme.palette.grey[100],
      [theme.breakpoints.down('sm')]: {
        bottom: -8,
      },
    },
    [theme.breakpoints.down('sm')]: {
      top: 72,
      marginBottom: 8,
    },
  },
  paper: {
    position: 'relative',
    zIndex: 2,
    padding: '14px 16px',
    [theme.breakpoints.down('sm')]: {
      padding: '8px 8px 0 8px',
    },
  },
  link: {
    textTransform: 'uppercase',
  },
  iconPlus: {
    width: 14,
    height: 14,
    marginRight: 13,
  },
  gridContainer: {
    flexWrap: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      flexDirection: 'column-reverse',
      alignItems: 'flex-start',
    },
  },
  gridItemActions: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 8,
    },
  },
  gridItemForm: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '100%',
      flexBasis: '100%',
    },
  },
  mobileButtonCounterContainer: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
    },
  },
  buttonFilter: {
    marginLeft: -10,
    marginBottom: -14,
    marginTop: -14,
  },
  buttonFilterActive: {
    color: theme.palette.primary[500],
  },
  iconFilter: {
    width: 16,
    height: 16,
  },
  collapseContainer: {
    marginLeft: -8,
    marginRight: -8,
    paddingLeft: 8,
    paddingRight: 8,
  },
  collapseEntered: {
    overflow: 'visible',
  },
  form: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: 8,
    },
  }
});

const PatientsFilter = ({
  form,
  buttonHref,
  buttonVariant,
  buttonDisabled,
  onMobileFilterBottonClick,
  mobileFilterExpanded,
  theme,
  filters,
  loading,
  count,
  items,
  classes,
}) => (
  <div className={classes.root}>
    <Paper className={classes.paper}>
      <Grid
        className={classes.gridContainer}
        container
        justify="space-between"
        alignItems="center"
        spacing={0}
      >
        <Grid
          className={classes.gridItemForm}
          item
          xs={10}
        > 
          <Collapse
            in={mobileFilterExpanded}
            classes={{
              container: classes.collapseContainer,
              entered: classes.collapseEntered,
            }}
            timeout={theme.transitions.duration.short}
          >
            <PatientsFilterForm form={form} className={classes.form} />
          </Collapse>
        </Grid>
        <Grid
          className={classes.gridItemActions}
          item
        >
          <div className={classes.mobileButtonCounterContainer}>
            <IconButton
              onClick={onMobileFilterBottonClick}
              className={classNames(classes.buttonFilter, {
                [classes.buttonFilterActive]: filters && Object.keys(filters).length > 0,
              })}
            >
              <IconFilter className={classes.iconFilter} />
            </IconButton>
            <Typography className={classes.typography}>
              Patients
              {(loading === 0 || (items && items.length > 0)) && (
                ` (${count})`
              )}
            </Typography>
          </div>
          {buttonVariant === 'default' &&
            <Button
              variant="raised"
              color="primary"
              disabled={buttonDisabled}
              {...buttonHref ? { href: buttonHref } : {}}
            >
              Add new patient
            </Button>
          }
          {buttonVariant === 'add' &&
            <Link
              className={classes.link}
              color="primary"
              bold
              size="lg"
              disabled={buttonDisabled}
              {...buttonHref ? { href: buttonHref } : {}}
            >
              <IconPlus className={classes.iconPlus} />
              Add new patient
            </Link>
          }
        </Grid>
      </Grid>
    </Paper>
  </div>
);

PatientsFilter.propTypes = {
  form: PropTypes.string.isRequired,
  buttonHref: PropTypes.string,
  buttonVariant: PropTypes.oneOf(['default', 'add']),
  buttonDisabled: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    iconPlus: PropTypes.string.isRequired,
  }).isRequired,
};

PatientsFilter.defaultProps = {
  buttonHref: null,
  buttonVariant: 'default',
  buttonDisabled: false,
};

export default withStyles(styles, { withTheme: true })(PatientsFilter);



// WEBPACK FOOTER //
// ./src/components/patient/PatientsFilter/PatientsFilter.js